/* pickle-behaviors.js — shared, idempotent behaviors for pickle-* sections.
   Re-initializes safely on Shopify Theme Editor section load/reorder events. */
(function () {
  function initReveal(root) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = (root || document).querySelectorAll('[data-pickle-reveal]:not([data-pickle-observed])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); el.setAttribute('data-pickle-observed', '1'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      el.setAttribute('data-pickle-observed', '1');
      io.observe(el);
    });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-pickle-tabgroup]:not([data-pickle-bound])').forEach(function (group) {
      group.setAttribute('data-pickle-bound', '1');
      var buttons = group.querySelectorAll('[data-pickle-tab-btn]');
      var panels = group.querySelectorAll('[data-pickle-tab-panel]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.getAttribute('data-pickle-tab-btn');
          buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-pickle-tab-panel') === idx); });
        });
      });
    });
  }

  function initStickyAtc(root) {
    (root || document).querySelectorAll('[data-pickle-sticky-atc]:not([data-pickle-bound])').forEach(function (bar) {
      bar.setAttribute('data-pickle-bound', '1');
      var anchorSel = bar.getAttribute('data-pickle-sticky-anchor');
      var anchor = anchorSel ? document.querySelector(anchorSel) : null;
      if (!anchor || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      io.observe(anchor);
    });
  }

  function initGalleryDots(root) {
    (root || document).querySelectorAll('[data-pickle-scroller]:not([data-pickle-bound])').forEach(function (scroller) {
      scroller.setAttribute('data-pickle-bound', '1');
      var prev = scroller.parentElement.querySelector('[data-pickle-prev]');
      var next = scroller.parentElement.querySelector('[data-pickle-next]');
      if (prev) prev.addEventListener('click', function () { scroller.scrollBy({ left: -Math.min(420, scroller.clientWidth * 0.9), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { scroller.scrollBy({ left: Math.min(420, scroller.clientWidth * 0.9), behavior: 'smooth' }); });
    });
  }

  function initAll(root) {
    initReveal(root);
    initTabs(root);
    initStickyAtc(root);
    initGalleryDots(root);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:reorder', function () { initAll(document); });
  if (document.readyState !== 'loading') initAll(document);
})();
